import documentsService from "./KYCDocumentsService";

export const DocumentsService = {
  uploadKYCDocumentPath: documentsService.uploadKYCDocumentPath,
  deleteKYCDocumentPath: documentsService.deleteKYCDocumentPath,
  getKYCDocumentsList: documentsService.getKYCDocumentsList,
  getKYCUploadedDocuments: documentsService.getKYCUploadedDocumentList,
  submitKYC: documentsService.submitKYC,
  generatePDF: documentsService.generatePDF
};
